import {AddShowingParams, AttendedShowingParams} from "features/authentication/types.services";
import {apiService} from "features/jwt/apiService";
import {apiErrorFrom} from "features/errors";
import {ShowingServiceEndpoints} from "features/authentication/services/ShowingService/config";

export class ShowingService {
    public static readonly addShowing = async (params: AddShowingParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<void>(ShowingServiceEndpoints.addShowing(), {
            ...params,
        });

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    };

    public static readonly deleteShowing = async (showingId: string) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.delete<void>(ShowingServiceEndpoints.deleteShowing(showingId));

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    };

    public static readonly attendedShowing = async (params: AttendedShowingParams) => {
        const { data, error, endpoint, statusCode, method, transportError } = await apiService.post<void>(ShowingServiceEndpoints.attendedShowing(params.stageId), params);

        if(error) {
            throw apiErrorFrom({ error, endpoint, statusCode, method, transportError });
        }

        return data;
    }
}
